export default {
  login: {
    tagline: '高度な3Dメッシュ生成 • 品質重視 • Web最適化',
    agreePrefix: 'ログインすることで、以下に同意したものとみなされます:',
    termsOfService: '利用規約',
    and: 'および',
    privacyPolicy: 'プライバシーポリシー',
    copyright: 'All rights reserved.',
  },
  resetPassword: {
    invalidLinkTitle: 'リセットリンクが無効です',
    invalidLinkBody: 'このパスワードリセットリンクは無効か、期限切れです。',
    backToLogin: 'ログインに戻る',
    subtitle: 'パスワードをリセット',
    copyright: 'All rights reserved.',
  },
  oauthConsent: {
    title: '{{clientName}} が Khorium アカウントの利用を求めています',
    intro: '許可すると、{{clientName}} は次のことができます:',
    scopes: {
      openid: 'あなたの本人確認',
      email: 'メールアドレスの参照',
      profile: '名前とプロフィール画像の参照',
    },
    notGranted: '次の項目は許可されません: {{scopes}}',
    allow: '許可',
    deny: '拒否',
    unknownApp: 'このアプリ',
    loading: 'リクエストを確認しています…',
    redirecting: 'アプリに戻っています…',
    done: 'このタブを閉じて、アプリに戻ってください。',
    errorTitle: 'アプリに接続できませんでした',
    errorBody: 'アプリに戻り、もう一度接続を始めてください。',
  },
  verifyEmail: {
    nudgeManaged:
      'メールアドレスの確認は組織で処理中です。確認前でも作業を続けられます。',
  },
  appShell: {
    errorFallback: '予期しないエラーが発生しました。',
    errorTitle: '問題が発生しました',
    goToDashboard: 'ダッシュボードへ移動',
  },
} as const;
